"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "@/components/ui/pagination";
import moment from "moment-jalaali";
import { Pencil, Eye, Search } from "lucide-react";

const ProductManageSection = ({ products }: any) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    const filteredProducts = products.filter((product: any) =>
        product.title.includes(searchTerm) ||
        product.name.includes(searchTerm) ||
        product.category?.categoryParent.includes(searchTerm) ||
        product.category?.categoryChild.includes(searchTerm)

    );

    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentProducts = filteredProducts.slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

    const handlePageChange = (page: any) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="rtl space-y-4 w-full bg-[#1A1525]/60 backdrop-blur-xl border border-white/10 rounded-xl shadow-lg p-6">
            <div className="flex items-center justify-between gap-4 mb-4">
                <h3 className="text-xl font-bold text-gray-300">مدیریت محصولات</h3>
                <div className="relative w-1/3">
                    <Input
                        type="text"
                        placeholder="جستجو بر اساس نام، دسته‌بندی..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="pr-10 bg-[#2D1F40] text-white placeholder-gray-400"
                    />
                    <Search className="absolute right-3 top-2 text-gray-400" />
                </div>
            </div>

            <Table className="w-full">
                <TableHeader>
                    <TableRow className="bg-[#2D1F40]">
                        <TableHead>تصویر</TableHead>
                        <TableHead>نام محصول</TableHead>
                        <TableHead>قیمت</TableHead>
                        <TableHead>واحد</TableHead>
                        <TableHead>موجودی</TableHead>
                        <TableHead>دسته‌بندی</TableHead>
                        <TableHead>تاریخ ایجاد</TableHead>
                        <TableHead>عملیات</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {currentProducts.map((product: any) => (
                        <TableRow key={product.id} className="hover:bg-white/10">
                            <TableCell>
                                <Image src={product.coverImage} alt={product.title} width={50} height={50} className="rounded-md object-cover" />
                            </TableCell>
                            <TableCell>{product.title}</TableCell>
                            <TableCell>{product.price.toLocaleString()}</TableCell>
                            <TableCell>{product.currency === "IRT" ? "تومان" : "USDT"}</TableCell>
                            <TableCell>{product.stock}</TableCell>
                            <TableCell>{product.categoryParent} / {product.categoryChild || ''}</TableCell>
                            <TableCell>{moment(product.createdAt).format("jYYYY/jMM/jDD")}</TableCell>
                            <TableCell className="flex gap-3">
                                <Link href={`/dashboard/products/edit/${product.id}`}>
                                    <Pencil className="w-5 h-5 text-gray-300 cursor-pointer" />
                                </Link>
                                <Link href={`/shop/${product.category}/${product.id}`}>
                                    <Eye className="w-5 h-5 text-gray-300 cursor-pointer" />
                                </Link>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <Pagination className="mt-4">
                <PaginationContent>
                    <PaginationItem>
                        <PaginationPrevious onClick={() => handlePageChange(currentPage - 1)} />
                    </PaginationItem>
                    {Array.from({ length: totalPages }, (_, i) => (
                        <PaginationItem key={i}>
                            <PaginationLink isActive={currentPage === i + 1} onClick={() => handlePageChange(i + 1)}>
                                {i + 1}
                            </PaginationLink>
                        </PaginationItem>
                    ))}
                    <PaginationItem>
                        <PaginationNext onClick={() => handlePageChange(currentPage + 1)} />
                    </PaginationItem>
                </PaginationContent>
            </Pagination>
        </div>
    );
};

export default ProductManageSection;
